import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-videos-player',
  templateUrl: './videos-player.component.html',
  styleUrls: ['./videos-player.component.scss']
})
export class VideosPlayerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
